var app = angular.module('leonardo');

/**
 * Maps supported legacy share deep links to their equivalent iO routes so
 * migrated users landing on historical share URLs end up in iO.
 *
 * Only share states have confirmed iO equivalents; all other legacy routes
 * intentionally return null (iO and legacy paths do not map 1:1).
 */
var IoShareRedirectService = function () {
  var service = {};

  var SHARE_STATE_MAP = {
    'share-attachment': { segment: 'attachment', param: 'id' },
    'share-document': { segment: 'document', param: 'url_uuid' }
  };

  /**
   * Build the iO URL for a legacy share ui-router state.
   * @returns {string|null} iO share URL, or null when the state has no iO
   * equivalent or the iO base URL is not configured.
   */
  service.getIoUrlForState = function (stateName, params) {
    var mapping = SHARE_STATE_MAP[stateName];
    var base = window.LEO_NEW_EXPERIENCE_URL;
    if (!mapping || !base) {
      return null;
    }
    var id = params ? params[mapping.param] : null;
    if (isNull(id) || isEmpty(id)) {
      return null;
    }
    return base.replace(/\/+$/, '') + '/share/' + mapping.segment + '/' + encodeURIComponent(id);
  };

  /**
   * Read the share state stored by the login redirect guard (url_redirect),
   * if any, and return its mapped iO URL. Clears the stored value when it
   * holds a share state so it cannot leak into a later login.
   * @returns {string|null}
   */
  service.consumeStoredShareUrl = function () {
    var stored = localStorage.getItem('url_redirect');
    if (!stored) {
      return null;
    }
    try {
      var parsed = JSON.parse(stored);
      var url = service.getIoUrlForState(parsed.url, parsed.params);
      if (url) {
        localStorage.removeItem('url_redirect');
      }
      return url;
    } catch (e) {
      return null;
    }
  };

  /**
   * Navigate to the iO URL, carrying the auth token through the same
   * from_forced/token contract the existing forced-migration redirect uses.
   */
  service.redirect = function (url) {
    var token = localStorage.getItem('jwt_token');
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    var params = 'from_forced=true' + (token ? '&token=' + encodeURIComponent(token) : '');
    window.location.href = url + separator + params;
  };

  return service;
};

app.factory('IoShareRedirectService', [IoShareRedirectService]);
